import { Injectable } from '@angular/core';
import { Action, State, Store, type StateContext } from '@ngxs/store';
import * as FlatActions from '@medsurf/flat-actions';
import { ApiControlService } from '@medsurf/flat-services';
import * as FlatStates from '../../internal';

export interface SlideControlStateModel {
  // Loaded Slides
  availableSlides: Set<string>;
}

@State<SlideControlStateModel>({
  name: 'slideControl',
  defaults: {
    availableSlides: new Set<string>(),
  }
})
@Injectable()
export class SlideControlState {
  constructor(public store: Store,
              public apiControlService: ApiControlService) {
  }

  //<editor-fold desc="Actions">

  @Action(FlatActions.SlideControlActions.GetSlideEntitySuccess)
  getSlideEntitySuccess({getState, patchState}: StateContext<SlideControlStateModel>,
                        {entityQueryResult}: FlatActions.SlideControlActions.GetSlideEntitySuccess) {
    const availableSlides = getState().availableSlides;
    if (!availableSlides.has(entityQueryResult.entity.id)) {
      availableSlides.add(entityQueryResult.entity.id);
      patchState({
        availableSlides
      });
    }
  }

  @Action(FlatActions.SlideControlActions.GetSlideEntitiesSuccess)
  getSlideEntitiesSuccess({getState, patchState}: StateContext<SlideControlStateModel>,
                          {entityQueryResults}: FlatActions.SlideControlActions.GetSlideEntitiesSuccess) {
    const availableSlides = getState().availableSlides;
    let hasChanges = false;
    for (const entityQueryResult of entityQueryResults) {
      if (!availableSlides.has(entityQueryResult.entity.id)) {
        availableSlides.add(entityQueryResult.entity.id);
        hasChanges = true;
      }
    }
    if (hasChanges) {
      patchState({
        availableSlides
      });
    }
  }

  @Action(FlatActions.SlideControlActions.GetSlideDataByPageId)
  getSlideDataByPageId({getState}: StateContext<SlideControlStateModel>,
                       {pageId}: FlatActions.SlideControlActions.GetSlideDataByPageId) {
    if (pageId) {
      const availableSlides = getState().availableSlides;
      if (!availableSlides.has(pageId)) {
        return this.apiControlService.sendMessage(
          new FlatActions.SlideControlActions.GetSlideDataByPageIdRequest(pageId)
        );
      }
    }
    return;
  }

  @Action(FlatActions.SlideControlActions.GetSlideDataBySlideId)
  getSlideDataBySlideId(state: StateContext<SlideControlStateModel>,
                        {slideId}: FlatActions.SlideControlActions.GetSlideDataBySlideId) {
    if (slideId) {
      return this.apiControlService.sendMessage(
        new FlatActions.SlideControlActions.GetSlideDataBySlideIdRequest(slideId)
      );
    }
    return;
  }
  
  @Action(FlatActions.SlideControlActions.AddAvailableSlide)
  addAvailableSlide({getState, patchState}: StateContext<SlideControlStateModel>,
                    {slideId}: FlatActions.SlideControlActions.AddAvailableSlide) {
    const availableSlides = getState().availableSlides;
    if (!availableSlides.has(slideId)) {
      availableSlides.add(slideId);
      patchState({
        availableSlides
      });
    }
  }
  
  @Action(FlatActions.SlideControlActions.RemoveAvailableSlide)
  removeAvailableSlide({getState, patchState}: StateContext<SlideControlStateModel>,
                       {slideId}: FlatActions.SlideControlActions.RemoveAvailableSlide) {
    const availableSlides = getState().availableSlides;
    if (!availableSlides.has(slideId)) {
      availableSlides.delete(slideId);
      patchState({
        availableSlides
      });
    }
  }

  //</editor-fold>
}
